import { UntitledIcon } from '@faceup/icons'
import { ulEye } from '@faceup/icons/ulEye'
import { ulEyeOff } from '@faceup/icons/ulEyeOff'
import { UnstyledButton, UserAvatar } from '@faceup/ui'
import { Avatar } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import { useRedaction } from './RedactionProvider'
import type { RedactTextType } from './redactionConstants'
import { getTextByTextType } from './redactText'

type UsernameAvatarRedactProps = {
  children: ReactNode
  type: RedactTextType
  text: string
}

export const UsernameAvatarRedact = (props: UsernameAvatarRedactProps) => {
  const { children, type, text: originalText } = props
  const { isRedactionActive, texts, redactText } = useRedaction()

  if (!isRedactionActive) {
    return <>{children}</>
  }

  const redactedText = getTextByTextType(texts, type)
  const text = redactedText ?? originalText

  if (type.type === 'sender') {
    return (
      <UserAvatar
        user={{
          name: text,
        }}
      />
    )
  }

  const shownName = text === originalText ? text : `User ${text}`

  // Show Avatar only if button hover, otherwise show UserAvatar
  return (
    <UnstyledButton
      className='group'
      onClick={() => {
        redactText(
          type,
          {
            start: 0,
            end: text.length,
            variant: redactedText === undefined ? 'redacted' : 'notRedacted',
          },
          originalText
        )
      }}
    >
      <div className='hidden group-hover:block'>
        <Avatar src={<UntitledIcon icon={text === originalText ? ulEyeOff : ulEye} />} />
      </div>
      <div className='block group-hover:hidden'>
        <UserAvatar
          user={{
            name: shownName,
          }}
        />
      </div>
    </UnstyledButton>
  )
}
